
import { Component, Vue, Watch } from 'vue-property-decorator';
import VueGridLayout from 'vue-grid-layout';
import WorkList from './components/index.vue';

import { getRepairWorkbench } from '@/api/workBench';
import { UserModule } from '@/store/modules/user';
import { returnLayout, returnPamars } from '@/utils/workBenchUtil';
import { WorkbenchLayoutModule } from '@/store/modules/workBench';

@Component({
  name: 'Worktable',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    WorkList
  }
})

export default class extends Vue {
  private layoutData: any = ''

  private layout: any = [];
  private locLayout:any=WorkbenchLayoutModule.getLayout;

  private isDraggable = true
  private pamars:any={
    order_information_type: 1,
    unfinish_order_information_size: 10,

    branch_company_type: 1,
    branch_company_size: 6,

    service_company_statistics_type: 1,
    service_company_statistics_size: 8,

    untreated_check_order_information_size: 3,

    order_bbs_information_size: 4
  }
  private toolsHeight = '100%';
  private minHt = window.innerHeight
  created() {
    this.layout = returnLayout();
    if (this.layout) {
      this.layout.map((item: any) => {
        let arr = this.locLayout.filter((i:any) => {
          return i.type === item.type;
        });
        if (arr && arr.length > 0) {
          item.isLocHave = true;
        }
      });
    }
    this.pamars = {
      ...this.pamars,
      ...returnPamars(this.layout)
    };
    this.getRepairWorkbench(this.pamars);
  }
  mounted() {
    this.toolsHeight = (document.getElementsByClassName('tools-main')[0] as any).clientHeight || (document.getElementsByClassName('tools-main')[0] as any).offsetHeight;
    (document.getElementsByClassName('tools-left')[0] as any).style.height = (parseInt(this.toolsHeight) - 120) + 'px';
  }
  private getRepairWorkbench(ps:any) {
    let pamars:any = {
      ...ps
    };
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    getRepairWorkbench(pamars).then((res:any) => {
      if (res.data) {
        this.layoutData = res.data;
      }
    });
  }

  private allPamarsClick(val:any) {

  }

  private deleteMenuHandle(val: any) {
    this.layout = this.layout.map((item: any) => {
      if (item.type === val.type) {
        item.isLocHave = false;
      }
      return item;
    });
    const index = this.locLayout.map((item: any) => item.type).indexOf(val.type);
    this.locLayout.splice(index, 1);
  }
  private addMenuHandle(val: any) {
    this.layout = this.layout.map((item: any) => {
      if (item.type === val.type) {
        item.isLocHave = true;
      }
      return item;
    });
    this.locLayout.unshift(val);
  }
  private saveLayout() {
    WorkbenchLayoutModule.setLayout(this.locLayout);
    this.$router.go(-1);
  }
  private cancleSaveLayout() {
    this.$router.go(-1);
  }
}

